import { render, staticRenderFns } from "./TheFooterLinksColumn.vue?vue&type=template&id=6e117542"
import script from "./TheFooterLinksColumn.vue?vue&type=script&lang=js"
export * from "./TheFooterLinksColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports